<template>
  <v-card
    class="align-center justify-center"
    height="350"
    img="https://cdn.discordapp.com/attachments/668983558211108880/751403699812827277/background_home_dark_small.png"
  >
    <div class="headline-text">
      <p class="white--text font-weight-bold" style="font-size:69px">BDO TRACKER</p>
    </div>
    <div class="searchbar">
      <v-row class="ma-2 pa-3">
        <v-btn-toggle v-model="charFamilyToggle" dark mandatory>
          <v-btn
            height="50"
            style="border-style: none;"
            color="rgba(15,15,15,1)"
            :class="{ 'active-button': charFamilyToggle === 0, 'rounded-r-0': true}"
          >Char</v-btn>
          <v-btn
            height="50"
            color="rgba(15,15,15,1)"
            :class="{ 'active-button': charFamilyToggle === 1, 'rounded-0': true}"
            style="border-style: none"
          >Family</v-btn>
        </v-btn-toggle>
        <v-text-field
          class="rounded-0"
          placeholder="Search for Player.."
          solo
          height="50"
          autofocus
          dense
          hide-details
          v-model="query"
        ></v-text-field>
        <v-btn
          height="50"
          class="rounded-l-0 rounded-lg"
          dark
          color="rgba(15,15,15,1)"
          :to="{path: '/character/' + query}"
        >
          <v-icon color="grey">mdi-magnify</v-icon>
        </v-btn>
      </v-row>
    </div>
    <div class="info-text">
      <v-row>
        <v-col>
          <span class="white--text font-weight-light body-1">
            Online Players:
            <span class="white--text font-weight-bold body-1">54013</span>
          </span>
        </v-col>
        <v-col>
          <span class="white--text font-weight-light body-1">
            Tracked Players:
            <span class="white--text font-weight-bold body-1">123k</span>
          </span>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SearchbarDesktop",
  data() {
    return {
      charFamilyToggle: 0,
      query: ""
    };
  }
};
</script>

<style scoped>
.searchbar {
  background-color: rgba(40, 40, 40, 1);
  position: absolute;
  left: 50px;
  top: 150px;
}
.headline-text {
  position: absolute;
  left: 50px;
  top: 60px;
}
.info-text {
  position: absolute;
  left: 50px;
  top: 240px;
}
.active-button {
  text-decoration: underline;
  text-decoration-color: greenyellow;
}
</style>